import React from 'react';
import { Outlet } from 'react-router-dom';
import ProjectRegistrationDetail from 'page/Application/ProjectRegistration/ProjectRegistrationDetail';
import ProjectRegistrationOverview from 'page/Application/ProjectRegistration/ProjectRegistrationOverview';

const ProjectRegistration = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default ProjectRegistration;

export { ProjectRegistrationDetail, ProjectRegistrationOverview };
